import { Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import icBookmarks from '@iconify/icons-ic/twotone-bookmarks';

import emojioneUS from '@iconify/icons-emojione/flag-for-flag-united-states';
import emojioneDE from '@iconify/icons-emojione/flag-for-flag-germany';
import emojioneFR from '@iconify/icons-emojione/flag-for-flag-france';
import emojioneCN from '@iconify/icons-emojione/flag-for-flag-china';
import emojioneTW from '@iconify/icons-emojione/flag-for-flag-taiwan';
import emojioneES from '@iconify/icons-emojione/flag-for-flag-spain';
import emojioneAR from '@iconify/icons-emojione/flag-for-flag-united-arab-emirates';
import emojioneHE from '@iconify/icons-emojione/flag-for-flag-israel';

import icMenu from '@iconify/icons-ic/twotone-menu';
import { ConfigService } from '../../services/config.service';
import icPersonAdd from '@iconify/icons-ic/twotone-person-add';
import icRadioButtonUnchecked from '@iconify/icons-ic/twotone-radio-button-unchecked';
import icPublic from '@iconify/icons-ic/twotone-public';
import icAssignmentTurnedIn from '@iconify/icons-ic/twotone-assignment-turned-in';
import icBallot from '@iconify/icons-ic/twotone-ballot';
import icDescription from '@iconify/icons-ic/twotone-description';
import icAssignment from '@iconify/icons-ic/twotone-assignment';
import icReceipt from '@iconify/icons-ic/twotone-receipt';
import icDoneAll from '@iconify/icons-ic/twotone-done-all';
import { NavigationService } from '../../services/navigation.service';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import { PopoverService } from '../../components/popover/popover.service';
import { MegaMenuComponent } from '../../components/mega-menu/mega-menu.component';
import icSearch from '@iconify/icons-ic/twotone-search';
import icSettings from '@iconify/icons-ic/twotone-settings';
import { TranslateService } from '@ngx-translate/core';
import { LanguageTranslationService } from '../../services/languageTranslationService/language-translation.service';
import { ToolbarService } from '../../../@vex/services/toolbar.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CandidatesService } from 'src/@vex/services/candidatesService/candidates.service';
import { Router } from '@angular/router';
import { PreferenceKeys } from 'src/app/interfaces/preference-keys.enum';

interface Food {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
  @Input() mobileQuery: boolean;
  myControl = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;

  navigationItems = this.navigationService.items;

  isHorizontalLayout$ = this.configService.config$.pipe(
    map(config => config.layout === 'horizontal')
  );
  isVerticalLayout$ = this.configService.config$.pipe(
    map(config => config.layout === 'vertical')
  );
  isNavbarInToolbar$ = this.configService.config$.pipe(
    map(config => config.navbar.position === 'in-toolbar')
  );
  isNavbarBelowToolbar$ = this.configService.config$.pipe(
    map(config => config.navbar.position === 'below-toolbar')
  );

  icSearch = icSearch;
  icBookmarks = icBookmarks;

  emojioneUS = emojioneUS;
  emojioneDE = emojioneDE;
  emojioneCN = emojioneCN;
  emojioneTW = emojioneTW;
  emojioneES = emojioneES;
  emojioneFR = emojioneFR;
  emojioneHE = emojioneHE;
  emojioneAR = emojioneAR;

  icPublic = icPublic;
  icRadioButtonUnchecked = icRadioButtonUnchecked;
  icMenu = icMenu;
  icPersonAdd = icPersonAdd;
  icAssignmentTurnedIn = icAssignmentTurnedIn;
  icBallot = icBallot;
  icDescription = icDescription;
  icAssignment = icAssignment;
  icReceipt = icReceipt;
  icDoneAll = icDoneAll;
  icSettings = icSettings;
  icArrowDropDown = icArrowDropDown;
  selectedValue: string = 'jobs';

  selectedLanguageIcon = emojioneUS;
  selectedLanguage = 'English';

  checkValue;

  searchedData: any = [];
  foods: Food[] = [
    { value: 'jobs', viewValue: 'JOBS' },
    { value: 'candidates', viewValue: 'CANDIDATES' },
  ];
  candidateValue;
  jobValue;

  userRole: number;

  constructor(
    private layoutService: LayoutService,
    public translate: TranslateService,
    private configService: ConfigService,
    private navigationService: NavigationService,
    private popoverService: PopoverService,
    private _languageTranslationService: LanguageTranslationService,
    private _toolbarService: ToolbarService,
    private _candidateService: CandidatesService,
    private _router: Router
  ) {}

  ngOnInit() {
    const defaultLanguage = localStorage.getItem(PreferenceKeys.SelectedLanguage) || 'en';
    this.selectLanguage(defaultLanguage, false);
  }

  onGetSearchValue(value) {
    this.searchedData = [];
    if (this.selectedValue === 'jobs') {
      if (value !== '') {
        const jobBody = {
          term: value,
        };
        this._toolbarService.getJobsDataByGlobalSearch(jobBody).subscribe(data => {
          this.searchedData = data;
        });
      }
    } else {
      if (value !== '') {
        const candidateBody = {
          term: value,
        };
        this._toolbarService
          .getCandidateDataByGlobalSearch(candidateBody)
          .subscribe(data => {
            this.searchedData = data;
          });
      }
    }
  }

  onOptionSelected(event) {
    console.log(this.searchedData);
    let data = this.searchedData.find(item => item.value === event.option.value);
    console.log('Option selected data', data);
    // Handle the selected option
  }

  searchValueChange(value) {
    if (value === 'candidates') {
      this.searchedData = [];
      this.selectedValue = 'candidates';
      this.myControl.reset();
    }
    if (value === 'jobs') {
      this.searchedData = [];
      this.selectedValue = 'jobs';
      this.myControl.reset();
    }
  }

  getSearchResult(data) {
    console.log('search data:', data);
    if (this.selectedValue === 'candidates') {
      this.candidateValue = data;
    }
    if (this.selectedValue === 'jobs') {
      this.jobValue = data;
    }
  }

  gotoSearch() {
    this.openSearchResult();
  }

  openSearchResult() {
    if (this.selectedValue === 'candidates') {
      localStorage.setItem('rid', this.candidateValue.id);
      this._candidateService.getJobIdAndCandiadte_JobId(
        this.candidateValue.jid,
        this.candidateValue.rid
      );
      this._router.navigate([`/apps/candidates/${this.candidateValue.rid}`]);
      this.myControl.reset();
    }
    if (this.selectedValue === 'jobs') {
      localStorage.setItem('jid', this.jobValue.id);
      this._router.navigate(['/apps/jobs/job-detail']);
      this.myControl.reset();
    }
  }

  openQuickpanel() {
    this.layoutService.openQuickpanel();
  }

  openSidenav() {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement) {
    this.popoverService.open({
      content: MegaMenuComponent,
      origin,
      position: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
    });
  }

  openSearch() {
    this.layoutService.openSearch();
  }

  openAdvancedSearch() {
    this._router.navigate(['/apps/search-advance']);
    this.myControl.reset();
  }

  selectLanguage(selected$: string, pushChanges: boolean = true) {
    switch (selected$) {
      case 'zh-CN':
        this.selectedLanguageIcon = emojioneCN;
        this.selectedLanguage = '简体中文';
        break;

      case 'zh-TW':
        this.selectedLanguageIcon = emojioneTW;
        this.selectedLanguage = '繁體中文';
        break;

      case 'fr':
        this.selectedLanguageIcon = emojioneFR;
        this.selectedLanguage = 'Français';
        break;

      case 'es':
        this.selectedLanguageIcon = emojioneES;
        this.selectedLanguage = 'Español';
        break;

      case 'de':
        this.selectedLanguageIcon = emojioneDE;
        this.selectedLanguage = 'Deutsche';
        break;

      case 'ar':
        this.selectedLanguageIcon = emojioneAR;
        this.selectedLanguage = 'عربي';
        break;

      case 'he':
        this.selectedLanguageIcon = emojioneHE;
        this.selectedLanguage = 'עִברִית';
        break;

      default:
        this.selectedLanguageIcon = emojioneUS;
        this.selectedLanguage = 'English';
        break;
    }

    if (pushChanges) {
      localStorage.setItem(PreferenceKeys.SelectedLanguage, selected$);
      this._languageTranslationService.selectedLanguage.next(selected$);
    }
  }
}
